export default __webpack_public_path__ + "static/media/RTR2004V_LateralDer.a2a38d4e.webp";